import React from 'react';

import { reDirectPage } from '../../../../lib/common';
import Button from '../../../../components/Button';
import ExcelBulkCategoryProductUploadModal from '../modal/ExcelBulkCategoryProductUploadModal';
import ProductCategoryLinkBulkStatusCard from '../ProductCategoryLinkBulkStatusCard';
import { CATEGORY_CREATE_URL_PATH } from '../../../../constants/service/common/urlConstants';
import CategoryList from '../CategoryList';
import CategorySearchBox from '../CategorySearchBox';
import './CategoryCreateManagementWrap.scss';

const CategoryCreateManagementWrap = (props) => {
  const {
    categoryListOption,
    excelFeature: { refetch },
    uploadModalFeature: {
      file,
      isUploadModalOpen,
      openUploadModal,
      closeUploadModal,
      onChangeFile,
      initializeFile,
      downloadSample,
      onSubmit,
    },
    bulkUploadFeature: {
      jobId,
      fileName,
      uploadPercent,
      job,
      isStatusUnavailable,
      isBusy,
      isDownloadingFailedCsv,
      downloadFailedCsv,
      dismiss,
    },
    onDeleteCategoryList,
  } = props;
  const { filterOption, selectedList } = categoryListOption;

  const deletable = selectedList.length > 0;

  return (
    <>
      <div className="category-create-management-wrap">
        <CategorySearchBox filterOption={filterOption} />
        <div className="category-option-button-wrap">
          {/* 진행 중인 업로드가 있으면 중복 요청(409)을 만들지 않도록 버튼을 막는다 */}
          <Button
            color="primary"
            isRadius
            text="상품 일괄 업로드"
            disabled={isBusy}
            onClick={openUploadModal}
          />
          <div className="category-option-button-right-section">
            <Button color="red" disabled={!deletable} isRadius text="삭제" onClick={onDeleteCategoryList} />
            <Button
              color="primary"
              isRadius
              text="1차 카테고리 생성"
              onClick={() => {
                reDirectPage({ path: CATEGORY_CREATE_URL_PATH });
              }}
            />
            <Button color="primary" isRadius text="엑셀 다운로드" onClick={() => refetch()} />
          </div>
        </div>
        <ProductCategoryLinkBulkStatusCard
          jobId={jobId}
          fileName={fileName}
          uploadPercent={uploadPercent}
          job={job}
          isStatusUnavailable={isStatusUnavailable}
          isDownloadingFailedCsv={isDownloadingFailedCsv}
          onDownloadFailedCsv={downloadFailedCsv}
          onDismiss={dismiss}
        />
        <CategoryList {...categoryListOption} />
      </div>
      <ExcelBulkCategoryProductUploadModal
        isOpen={isUploadModalOpen}
        file={file}
        onChange={onChangeFile}
        onSubmit={onSubmit}
        downloadSample={downloadSample}
        closeModal={() => {
          closeUploadModal();
          initializeFile();
        }}
      />
    </>
  );
};

export default CategoryCreateManagementWrap;
